/**
 * Local Groups Map - Geolocation Handler
 *
 * Wraps the browser's Geolocation API with error handling.
 *
 * @module localGroupsMap/geolocation
 */

import {CONFIG} from './config.js';

/**
 * Request browser geolocation.
 *
 * @param {function({lat: number, lng: number}): void} onSuccess - Called with GPS coordinates on success
 * @param {function(GeolocationPositionError): void} [onError] - Called with error on failure
 */
export function requestGeolocation(onSuccess, onError) {
    if (!('geolocation' in navigator)) {
        if (onError) {
            onError({code: 2, message: 'Geolocation unavailable'});
        }
        return;
    }

    navigator.geolocation.getCurrentPosition(
        (position) => {
            onSuccess({
                lat: position.coords.latitude,
                lng: position.coords.longitude,
            });
        },
        onError,
        CONFIG.geolocation
    );
}
